import notFoundImage from '@assets/404.png';
import { LinkButton } from '@components/linkComponents';
import { t } from '@i18n';

export default function NotFound() {
  return (
    <div
      css={{
        flex: 1,
        width: '100%',
        height: '100%',
        padding: '10%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 'var(--mantine-spacing-md)',
        textAlign: 'center',
      }}
    >
      <h1>{t('notFound.title')} </h1>

      <img
        src={notFoundImage}
        alt="Not Found"
        css={{
          maxWidth: '100%',
          maxHeight: '80%',
          objectFit: 'contain',
        }}
      />

      <p>{t('notFound.message')}</p>
      <LinkButton to="/">{t('notFound.backToHome')}</LinkButton>
    </div>
  );
}
